import React from "react";
import PropTypes from "prop-types";
import { TableRow, TableCell, Checkbox, TableSortLabel } from "@mui/material";
import { COLOR_CODE } from "@/utils/constants/colors";

const DataTableHead = ({
  columns,
  sortConfig,
  handleSort,
  isSelectAll,
  records,
  selectedRows,
  handleSelectAll
}) => (

  <TableRow>
    <TableCell sx={{
      width: '60px',
    }}>
      <Checkbox
        size="small"
        className="custom-checkbox"
        checked={isSelectAll || (records?.length > 0 && records.every(record =>
          selectedRows.some(selected => selected.uuid === record.uuid)
        ))}
        onChange={handleSelectAll}
        indeterminate={!isSelectAll && selectedRows?.length > 0 && selectedRows?.length < records.length}
      />
    </TableCell>
    {columns.map((column, columnIndex) => {
      const isActive = sortConfig?.key === column.name_of_db_column;
      const sortDirection = isActive ? (sortConfig?.direction || 'asc') : 'asc';
      const shouldHideSortIcon = column?.hideSortIcon
        ? true
        : !isActive;

      return (
        <TableCell
          className="custom-data-table-cell"
          key={`header-${columnIndex}`}
          align="left"
        >
          <TableSortLabel
            active={isActive}
            direction={sortDirection}
            onClick={() => {
              if (!column?.hideSortIcon) {
                handleSort(column.name_of_db_column);
              }
            }}
            hideSortIcon={shouldHideSortIcon}
            sx={{
              color: `${COLOR_CODE._EFEFEF} !important`,
              '&.Mui-active': {
                color: `${COLOR_CODE._EFEFEF} !important`,
              },
              '&:hover': {
                color: `${COLOR_CODE._EFEFEF} !important`,
              },
              '& .MuiTableSortLabel-icon': {
                color: `${COLOR_CODE._EFEFEF} !important`,
              },
            }}
          >
            {column.label_of_column}
          </TableSortLabel>
        </TableCell>
      );
    })}
    <TableCell sx={{
      width: '60px',
    }}>
    </TableCell>
  </TableRow>

);

DataTableHead.propTypes = {
  columns: PropTypes.array.isRequired,
  sortConfig: PropTypes.object,
  handleSort: PropTypes.func.isRequired,
  isSelectAll: PropTypes.bool.isRequired,
  records: PropTypes.array.isRequired,
  selectedRows: PropTypes.array.isRequired,
  handleSelectAll: PropTypes.func.isRequired
};

export default DataTableHead;
